export default __webpack_public_path__ + "static/8-9281dd48684d7b3b8620414a951058ef.png";